module.exports = __webpack_public_path__ + "img/mobile_2.6a461d41.png";